<tooltip-popover *ngIf="tooltip_content"
                 [tooltip_content]="tooltip_content">
</tooltip-popover>
